import React from 'react';
import { Row, Col } from 'tea-component';
import GameItem from './GameItem';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { PLACEHOLDER } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';

import type { IBaseProps, IGameType } from '@/pages/intelligence/types/common';
import type { IGameData } from '../types';

const GAME_TYPES_NAMES: {
  [key in IGameType]: string;
} = {
  mobile: 'dbi_mobile_games',
  pc: 'dbi_pc_games',
  console: 'dbi_console_games',
};

interface IGameListProps extends IBaseProps {
  entityType: IGameType;
  gamesTotal: number;
  gamesDate: string;
  games: IGameData[];
}

const GameList: React.FC<IGameListProps> = (props) => {
  const { entityType, gamesTotal, gamesDate, games: gamesOuter } = props;

  const { formatMessage } = useIntlExtend();

  const gameTypeLocaleKey = GAME_TYPES_NAMES[entityType];
  const gameTypeName = gameTypeLocaleKey ? formatMessage({ id: gameTypeLocaleKey }) : PLACEHOLDER;
  const games = gamesOuter?.slice(0, 6);

  return (
    <div className="dbi-games-context">
      <div className="games-flex">
        <span className="games-num">{gamesTotal}</span>
        <span className="games-title">{gameTypeName}</span>
      </div>
      <div className="games-desc">{gamesDate || PLACEHOLDER}</div>
      <Row>
        {games?.map((game: any, idx: any) => (
          <Col key={idx} span={8}>
            <GameItem entityType={entityType} game={game} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default GameList;
